import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { twMerge } from "tailwind-merge";
var TAGS_ICONS_MAP = [{
  key: "new",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/used.svg",
    alt: "key"
  })
}, {
  key: "used",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/used.svg",
    alt: "key"
  })
}, {
  key: "low-odometer",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/speedometer.svg",
    alt: "key"
  })
}, {
  key: "perfect",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/perfect-condition.svg",
    alt: "key"
  })
}, {
  key: "odometer",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/speedometer.svg",
    alt: "key"
  })
}, {
  key: "pre-registered",
  icon: /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/mlohaha.svg",
    alt: "key"
  })
}];
var ModernCardTags = function ModernCardTags(_ref) {
  var tags = _ref.tags,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  var getIcon = function getIcon(key) {
    var tagIcon = TAGS_ICONS_MAP.find(function (tag) {
      return tag.key === key;
    });
    return tagIcon === null || tagIcon === void 0 ? void 0 : tagIcon.icon;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "posts-card-tags-container",
    className: twMerge("mt-4 mb-3 flex items-end", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-2"
  }, tags.map(function (tag, idx) {
    return /*#__PURE__*/React.createElement("div", {
      id: "posts-card-tag-".concat(tag.key),
      key: idx,
      className: "text-xs rounded text-gray-text font-medium flex items-center gap-1 py-0.5 px-2 bg-[#F3F7FA]"
    }, (tag === null || tag === void 0 ? void 0 : tag.key) && /*#__PURE__*/React.createElement("span", {
      className: "h-3"
    }, getIcon(tag.key)), /*#__PURE__*/React.createElement("span", null, tag.text));
  }))));
};
export default ModernCardTags;